var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3263_1552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6078 16.333L19.5478 11.2009C19.2887 11.0131 18.9448 10.9848 18.6608 11.1308C18.3746 11.2756 18.1958 11.5698 18.1958 11.8877V22.1484C18.1958 22.4698 18.3746 22.7628 18.6608 22.9076C18.7819 22.9687 18.9142 22.9993 19.0478 22.9993C19.222 22.9993 19.3985 22.9438 19.5478 22.8341L26.6078 17.7065C26.8307 17.5425 26.9608 17.289 26.9608 17.0198C26.962 16.746 26.8285 16.4937 26.6078 16.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0006 0C11.6099 0 4 7.60986 4 17.0006C4 26.3879 11.6099 33.9955 21.0006 33.9955C30.389 33.9955 38 26.3867 38 17.0006C38.0011 7.60986 30.389 0 21.0006 0ZM21.0006 31.159C13.1803 31.159 6.83984 24.822 6.83984 17.0006C6.83984 9.18252 13.1803 2.83758 21.0006 2.83758C28.8197 2.83758 35.159 9.18139 35.159 17.0006C35.1602 24.822 28.8197 31.159 21.0006 31.159Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3263_1552",
    x: 0,
    y: 0,
    width: 42,
    height: 41.9955,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3263_1552"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3263_1552",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.99419d6aae63c9608414ff7dc5d6f36d.svg";
export { ForwardRef as ReactComponent };